import slugify from 'slugify';

export const itemsPerPage = 9;
export const maxLength = 7;

export const getPaginationItems = (
  currentPage: number,
  lastPage: number,
  maxLengthLocal: number,
) => {
  const res: Array<number> = [];

  // handle lastPage less than maxLengthLocal
  if (lastPage <= maxLengthLocal) {
    for (let i = 1; i <= lastPage; i += 1) {
      res.push(i);
    }
  } else {
    // handle ellipsis logics
    const firstPage = 1;
    const confirmedPagesCount = 3;
    const deductedMaxLength = maxLengthLocal - confirmedPagesCount;
    const sideLength = deductedMaxLength / 2;

    // handle ellipsis in the middle
    if (
      currentPage - firstPage < sideLength
      || lastPage - currentPage < sideLength
    ) {
      for (let j = 1; j <= sideLength + firstPage; j += 1) {
        res.push(j);
      }

      res.push(NaN);

      for (let k = lastPage - sideLength; k <= lastPage; k += 1) {
        res.push(k);
      }
    } else if (
      // handle two ellipsis
      currentPage - firstPage >= deductedMaxLength
      && lastPage - currentPage >= deductedMaxLength
    ) {
      const deductedSideLength = sideLength - 1;

      res.push(1);
      res.push(NaN);

      for (
        let l = currentPage - deductedSideLength;
        l <= currentPage + deductedSideLength;
        l += 1
      ) {
        res.push(l);
      }

      res.push(NaN);
      res.push(lastPage);
    } else {
      // handle ellipsis not in the middle
      const isNearFirstPage = currentPage - firstPage < lastPage - currentPage;
      let remainingLength = maxLengthLocal;

      if (isNearFirstPage) {
        for (let m = 1; m <= currentPage + 1; m += 1) {
          res.push(m);
          remainingLength -= 1;
        }

        res.push(NaN);
        remainingLength -= 1;

        for (let n = lastPage - (remainingLength - 1); n <= lastPage; n += 1) {
          res.push(n);
        }
      } else {
        for (let o = lastPage; o >= currentPage - 1; o -= 1) {
          res.unshift(o);
          remainingLength -= 1;
        }

        res.unshift(NaN);
        remainingLength -= 1;

        for (let p = remainingLength; p >= 1; p -= 1) {
          res.unshift(p);
        }
      }
    }
  }

  return res;
};

export const generateSlugifyUrl = (jobdata: any) => `/job-details/${slugify(
  `${jobdata.jobTitle} ${jobdata.location[0]} ${jobdata.jobId} ${jobdata.jobOrderId}`,
  { lower: true },
)}`;
